import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default function CUILoadingOverlayDirective () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      toggle: '=',
      message: '@'
    },
    template: require('./loading-overlay.jade')(jadeLocals),
    link: (scope, el, attrs) => {
      scope.hide = () => scope.toggle = false;
      scope.message = attrs.message || 'Processing...';
    }
  }
};



// WEBPACK FOOTER //
// ./source/client/layout-components/loading-overlay/loading-overlay.dir.js